var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{staticClass:"main"},[_c('div',{staticClass:"flex",staticStyle:{"width":"100%"}},[_c('TeamsListing',{staticStyle:{"width":"600px"},on:{"click":_vm.dressId}}),_c('InsideTeam',{attrs:{"material-id":_vm.dressIdShow},on:{"click":_vm.colorId}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }